import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import PWAConfigSection from './PWAConfigSection';
import ParentDocCard from '../common/ParentDocCard';
import CustomLoader from '../common/CustomLoader';
import { prepS3Url } from '../../common/utils/plugin_utils';
import showAlert from '../../common/utils/alert';
import {
  disableIt,
  disablePWA,
  enableIt,
  enablePWA,
  wantBeAbleToRevert,
} from '../../common/docs/content';

export class PwaConfiguration extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
  }

  handlePWAConfigSubmit = (values, isNew = true) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.saveProjectPwaConfig({
      projectId,
      version,
      data: values,
      isNew,
    });
  };

  handlePWAConfigDelete = () => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => actions.deleteProjectPwaConfig({ projectId, version });
    showAlert(wantBeAbleToRevert, preConfirm, disableIt);
  };
  handleTogglePWA = () => {
    const { appSetting, match, actions } = this.props;
    const { params } = match;
    const { projectId, version } = params;
    const { projectDetail } = appSetting;
    let togglePWA = !projectDetail.enablePWA;
    const preConfirm = () => actions.togglePwa({ projectId, version, data: {} });
    showAlert(togglePWA ? enablePWA : disablePWA, preConfirm, togglePWA ? enableIt : disableIt);
  };

  render() {
    const { appSetting, home, match } = this.props || {};
    const { params } = match;
    const { projectId } = params;
    const {
      projectDetail,
      loadProjectDetailAppSettingPending,
      saveProjectPwaConfigPending,
      permissionFlags,
    } = appSetting;
    const { iPlugins } = home;
    if (loadProjectDetailAppSettingPending || !projectDetail) {
      return (
        <CommonPageComponent>
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailAppSettingPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const s3Url = prepS3Url(iPlugins, null, true);
    const { enablePWA, pwaConfig } = projectDetail;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'pwaConfig'} projectDetail={projectDetail} />
        <PWAConfigSection
          enablePWA={enablePWA}
          pwaConfig={pwaConfig}
          projectId={projectId}
          iPlugins={iPlugins}
          s3Url={s3Url}
          saveProjectPwaConfigPending={saveProjectPwaConfigPending}
          permissionsArray={permissionsArray}
          handleTogglePWA={this.handleTogglePWA}
          handlePWAConfigSubmit={this.handlePWAConfigSubmit}
          handlePWAConfigDelete={this.handlePWAConfigDelete}
        />
        <ParentDocCard>
          <h4>
            <b>About PWA Configuration</b>
          </h4>
          <p>Coming soon</p>
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PwaConfiguration);
